import { LocationApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { BikesLocation } from '@/types/location';
import {
    RegisterPostRequest,
    UnregisterPostRequest
} from '@/types/http-payload/location';
import { REGISTER_STATUS } from '@/types/enums';

export default class BikesLocationStore extends BaseStore {
    bikeRegisterLocations: BikesLocation[] = [];
    totalRecordBikeRegisterLocation: number = 0;
    defaultPagingBikeRegisterLocation: TableState = this.defaultPaging;
    pagingBikeRegisterLocation: TableState = this.defaultPagingBikeRegisterLocation;

    defaultKeepSearchParams?: Record<string, any> = {
        isRegis: Boolean(REGISTER_STATUS.UNREGISTER)
    };

    keepSearchParamsRegisterLocations?: Record<string, any> = this.defaultKeepSearchParams;

    api: LocationApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            bikeRegisterLocations: observable,
            totalRecordBikeRegisterLocation: observable,
            pagingBikeRegisterLocation: observable,
            defaultKeepSearchParams: observable,
            keepSearchParamsRegisterLocations: observable,
            getBikeByLocation: flow.bound,
            registerBike: flow.bound,
            unregisterBike: flow.bound
        });
        this.api = new LocationApi();
    }

    // for bike
    *getBikeByLocation(searchParams, paging?: TableState) {
        try {
            const payload = {
                ...this.convertPagingFromTableToRequest(
                    paging ?? this.pagingBikeRegisterLocation
                ),
                ...searchParams
            };
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getBikeByLocation,
                payload
            );
            if (res.ok) {
                this.bikeRegisterLocations = res.data.elements;
                this.pagingBikeRegisterLocation = {
                    ...this.pagingBikeRegisterLocation,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(
                        res.data.paginate
                    )
                };
                this.totalRecordBikeRegisterLocation = res.data.paginate.totalRecord;
                return true;
            }
            return false;
        } catch (error) { }
    }

    *registerBike(payload: RegisterPostRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.registerBike,
                payload
            );
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) { }
    }

    *unregisterBike(payload: UnregisterPostRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.unregisterBike,
                payload
            );
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) { }
    }

    clean(): void {
        super.clean();

        this.bikeRegisterLocations = [];
        this.totalRecordBikeRegisterLocation = 0;
        this.pagingBikeRegisterLocation = this.defaultPagingBikeRegisterLocation;
        this.keepSearchParamsRegisterLocations = this.defaultKeepSearchParams;
    }
}
